import { Injectable } from '@angular/core';
import { forkJoin, merge, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppAdapter } from 'src/app/adapters/app-info/app.adapter';
import { TextZoomAdapter } from 'src/app/adapters/text-zoom/text-zoom.adapter';

@Injectable({
  providedIn: 'root'
})
export class TextZoomUseCase {

  constructor(
    private textZoomAdapter: TextZoomAdapter,
    private appAdapter: AppAdapter
  ) {}

  monitorTextZoomChanges(): Observable<void> {
    const monitorTextZoomStream = merge(
      this.setAppZoomIfNecessary(),
      this.appAdapter
        .getAppResumeStream()
        .pipe(
          switchMap(() => {
            return this.setAppZoomIfNecessary();
          })
        )
    );

    return monitorTextZoomStream;
  }

  private setAppZoomIfNecessary(): Observable<void> {
    const getZoomLevelsObs = forkJoin([
      this.textZoomAdapter.getSystemZoom(),
      this.textZoomAdapter.getAppZoom()
    ]);

    const setAppIfNeededObs = getZoomLevelsObs.pipe(
      switchMap(([systemZoom, appZoom]) => {
        if (systemZoom !== appZoom) {
          return this.textZoomAdapter.setAppZoom(systemZoom);
        }

        return of(undefined)
      })
    );

    return setAppIfNeededObs;
  }
}